import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Box, CircularProgress, Alert } from '@mui/material';

const ProtectedRoute = ({ 
  children, 
  requireAdmin = false, 
  requirePermission = null 
}) => {
  const { user, loading, isAuthenticated, isAdmin, hasPermission } = useAuth();
  const location = useLocation();

  // Show loading while checking authentication
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '50vh'
        }}
      >
        <CircularProgress size={40} />
      </Box>
    );
  }

  // Not authenticated - redirect to login
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check admin requirement
  if (requireAdmin && !isAdmin) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Access denied. Administrator privileges required.
        </Alert>
      </Box>
    );
  }

  // Check specific permission
  if (requirePermission && !hasPermission(requirePermission)) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Access denied. You don't have permission to access this resource.
        </Alert>
      </Box>
    );
  }

  // User is authenticated and has required permissions
  return children;
};

export default ProtectedRoute;